<script setup>
import Loader from "@/components/Loader.vue";
import MaintenanceScreen from "@/components/MaintenanceScreen.vue";

import { useStore } from "vuex";

import useUserGuiding from "@/utils/userGuiding";

const store = useStore();
const isLoading = computed(() => store.state.shared.isLoading);
const isMaintenanceMode = import.meta.env.VITE_MAINTENANCE_MODE_ENABLED === 'true';

onMounted(() => {
  const user = store.state.auth.user;

  useUserGuiding(user);
});
</script>
<template>
  <MaintenanceScreen v-if="isMaintenanceMode" />
  <template v-else>
    <Loader v-if="isLoading" />
    <router-view />
  </template>
</template>
